import { relevantCategoryData } from '../constants';

const findPosterURL = (category: string) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const poster of relevantCategoryData) {
    if (poster.Classes?.includes(category) || poster.SubTypes?.includes(category)) {
      return poster.URL;
    }
  }
  return `/search/templates/${category}`;
};
export default findPosterURL;
